<div class="bg-white rounded-lg shadow-sm p-6 w-full max-w-md mb-5">
  <h2 class="text-xl font-bold mb-4">Propina para el repartidor</h2>

  <div class="space-y-4">
    <!-- Descripción -->
    <p class="text-gray-600 mb-2">Agradece el servicio de entrega con una propina</p>

    <!-- Opciones de propina -->
    <div class="grid grid-cols-5 gap-2 mb-4">
      @for (tip of tips; track $index) {
        <button
          (click)="selectTip(tip)"
          class="py-2 px-3 rounded-lg text-center transition-colors duration-200"
          [class.bg-yellow-400]="selectedTip === tip && !showCustomInput"
          [class.text-gray-800]="selectedTip === tip && !showCustomInput"
          [class.bg-gray-100]="selectedTip !== tip || showCustomInput"
          [class.hover:bg-gray-200]="selectedTip !== tip || showCustomInput"
          [class.text-gray-700]="selectedTip !== tip || showCustomInput"
        >
          ${{tip}}
        </button>
      }
    </div>

    <!-- Opción personalizada -->
    <div class="flex items-center">
      <button
        (click)="toggleCustomInput()"
        class="flex items-center text-gray-700 hover:text-gray-900 transition-colors duration-200"
        [class.text-yellow-600]="showCustomInput"
      >
        <span class="mr-2 text-sm font-medium">Personalizada</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
      </button>
    </div>

    <!-- Input personalizado -->
    @if (showCustomInput) {
      <div class="mt-3">
        <div class="relative">
          <span class="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-700">$</span>
          <input
            type="number"
            [(ngModel)]="customTip"
            (ngModelChange)="onCustomTipChange()"
            class="w-full pl-8 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
            placeholder="Ingresa el monto"
            min="0"
          >
        </div>
      </div>
    }

    <!-- Línea divisoria -->
    <div class="border-t border-gray-200 my-2"></div>

    <!-- Resumen de propina -->
    <div class="flex justify-between items-center">
      <span class="text-gray-700">Propina seleccionada</span>
      @if (selectedTip) {
        <span class="font-medium">${{selectedTip}}</span>
      } @else {
        <span class="font-medium text-gray-500">$0</span>
      }
    </div>
  </div>
</div>